export default __webpack_public_path__ + "static/media/particles-web-theme1.ae5e65ef.svg";